/* GrokBot 2026-10-17 · smart Críticas e Prémios filter. Markup/data: snippets/vg-crit-filter.liquid.
   Drives the real Shopify checkboxes (filter.p.m.custom.criticas_e_premios) -> theme facet-filters.js AJAX + URL. */
(function () {
  'use strict';
  var OPEN = (window.__vgcfOpen = window.__vgcfOpen || { k: null });
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function fmt(n, loc) { var s = String(n); if (s.indexOf('.') > -1 && /\.0+$/.test(s)) s = s.replace(/\.0+$/, ''); return loc === 'en' ? s : s.replace('.', ','); }
  function disp(o, loc) { var n = fmt(o.s, loc) + (o.plus ? '+' : ''); return o.sc === 20 ? n + '/20' : n + ' pts'; }

  function init(root) {
    if (root.dataset.vgcfInit) return;
    root.dataset.vgcfInit = '1';
    var details = root.closest('details');
    var form = root.closest('form') || document;
    var param = root.dataset.param, loc = root.dataset.loc || 'pt';
    var T = (root.dataset.t || '').split('|');
    var t = { choose: T[0], back: T[1], min: T[2], all: T[3], clear: T[4], wines: T[5], other: T[6], remove: T[7], scores: T[8], see: T[9] };
    var data;
    try { data = JSON.parse(root.querySelector('[data-vgcf-data]').textContent); } catch (e) { return; }
    var tpl = {}, tpl20 = {};
    root.querySelectorAll('template[data-vgcf-medal]').forEach(function (x) { tpl[x.dataset.vgcfMedal] = x; });
    root.querySelectorAll('template[data-vgcf-medal20]').forEach(function (x) { tpl20[x.dataset.vgcfMedal20] = x; });
    var inputs = {};
    form.querySelectorAll('input[type="checkbox"]').forEach(function (i) { if (i.name === param) inputs[i.value] = i; });

    // group: critic -> score options (real scale kept; norm only for ordering)
    var G = {}, order = [];
    data.forEach(function (d) {
      if (!inputs[d.v]) return;
      var k = d.k || 'AW';
      if (!G[k]) { G[k] = { k: k, n: d.k ? d.n : t.other, opts: {}, list: [], count: 0, other: !d.k }; order.push(k); }
      var g = G[k];
      var plus = d.k ? /^\s*[\d.,]+\s*\+/.test(d.v) : false;
      var id = d.k ? d.sc + ':' + d.s + (plus ? '+' : '') : 'o:' + d.v;
      var o = g.opts[id];
      if (!o) {
        o = g.opts[id] = { id: id, s: d.s, sc: d.sc, plus: plus, norm: d.k ? (d.sc === 20 ? d.s * 5 : d.s) + (plus ? 0.25 : 0) : 0, vals: [], c: 0, act: 0, lab: d.k ? null : d.l };
        g.list.push(o);
      }
      o.vals.push(d.v); o.c += d.c; if (d.a) o.act++; g.count += d.c;
    });
    if (!order.length) return;
    order.forEach(function (k) {
      var g = G[k];
      g.list.sort(function (a, b) { return a.norm - b.norm || (a.lab || '').localeCompare(b.lab || ''); });
      g.list.forEach(function (o, i) { o.on = o.act > 0 && o.act === o.vals.length; o.i = i; });
      g.sel = g.list.filter(function (o) { return o.on; });
      g.top = g.other ? null : g.list[g.list.length - 1];
    });
    order.sort(function (a, b) { return (G[a].other - G[b].other) || (G[b].count - G[a].count); });

    function medal(k, o, size) {
      var x = (o && o.sc === 20 ? (tpl20[k] || tpl[k]) : (tpl[k] || tpl20[k])) || tpl.AW;
      if (!x) return '';
      var svg = x.content.firstElementChild.cloneNode(true);
      svg.setAttribute('width', size); svg.setAttribute('height', size);
      svg.removeAttribute('style') ; svg.setAttribute('style', x.content.firstElementChild.getAttribute('style') || '');
      svg.classList.remove('vgmd--prem');
      if (o && o.s != null) {
        svg.querySelectorAll('.vgmd-s').forEach(function (n) { n.textContent = fmt(o.s, loc); var L = n.textContent.length; n.setAttribute('font-size', L <= 2 ? 42 : L === 3 ? 35 : 31); });
        svg.querySelectorAll('.vgmd-u').forEach(function (n) { n.textContent = o.sc === 20 ? '/20' : 'PTS'; });
      }
      var w = document.createElement('span'); w.className = 'vgcf-m'; w.appendChild(svg); return w.outerHTML;
    }
    function summary(g) {
      if (g.other) return g.sel.map(function (o) { return o.lab; }).join(' · ');
      var s = g.sel, L = g.list;
      if (s.length > 1 && s[s.length - 1] === L[L.length - 1] && L.slice(s[0].i).every(function (o) { return o.on; })) return '≥ ' + disp(s[0], loc);
      return s.map(function (o) { return disp(o, loc); }).join(' · ');
    }
    function apply(changes) {
      var last = null;
      changes.forEach(function (c) { var i = inputs[c[0]]; if (i && i.checked !== c[1]) { i.checked = c[1]; last = i; } });
      if (last) { OPEN.f = document.activeElement && document.activeElement.id; root.classList.add('is-busy'); last.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    function setOpt(o, on) { return o.vals.map(function (v) { return [v, on]; }); }

    var uid = param.replace(/[^a-z0-9]/gi, '');
    var h = '';
    // selected chips
    var sel = order.filter(function (k) { return G[k].sel.length; });
    h += '<div class="vgcf__sel"' + (sel.length ? '' : ' hidden') + '>';
    sel.forEach(function (k) {
      var g = G[k];
      h += '<button type="button" class="vgcf-chip" id="vgcf-x-' + k + '" data-x="' + k + '" aria-label="' + esc(t.remove + ': ' + g.n + ' ' + summary(g)) + '">' + medal(k, g.sel[g.sel.length - 1], 26) +
        '<span class="vgcf-chip__t"><b>' + esc(g.n) + '</b> ' + esc(summary(g)) + '</span><span class="vgcf-chip__x" aria-hidden="true">×</span></button>';
    });
    h += '</div><div class="vgcf__stage">';
    // step 1: critic grid
    h += '<div class="vgcf__grid" role="group" aria-label="' + esc(t.choose) + '">';
    order.forEach(function (k) {
      var g = G[k];
      h += '<button type="button" class="vgcf-t' + (g.sel.length ? ' is-on' : '') + '" id="vgcf-t-' + uid + '-' + k + '" data-k="' + k + '" aria-controls="vgcf-p-' + uid + '" aria-label="' + esc(t.see + ' ' + g.n + ' (' + g.count + ' ' + t.wines + ')') + '">' +
        medal(k, g.top, 50) + '<span class="vgcf-t__n">' + esc(g.n) + '</span><span class="vgcf-t__c">' + g.count + '</span>' + (g.sel.length ? '<span class="vgcf-t__b" aria-hidden="true">' + g.sel.length + '</span>' : '') + '</button>';
    });
    h += '</div><div class="vgcf__panel" id="vgcf-p-' + uid + '" hidden></div></div>';
    root.innerHTML = h;
    root.hidden = false;
    if (details) details.classList.add('vgcf-on');

    var grid = root.querySelector('.vgcf__grid'), panel = root.querySelector('.vgcf__panel');

    function openPanel(k, anim) {
      var g = G[k]; if (!g) return;
      OPEN.k = k;
      var p = '<div class="vgcf-p__hd"><button type="button" class="vgcf-back" id="vgcf-b-' + uid + '"><span aria-hidden="true">←</span> ' + esc(t.back) + '</button>' +
        (g.sel.length ? '<button type="button" class="vgcf-clr link text-sm" id="vgcf-c-' + uid + '">' + esc(t.clear) + '</button>' : '') + '</div>' +
        '<div class="vgcf-p__id">' + medal(k, g.sel.length ? g.sel[g.sel.length - 1] : g.top, 54) + '<div><div class="vgcf-p__n">' + esc(g.n) + '</div><div class="vgcf-p__c">' + g.count + ' ' + esc(t.wines) + '</div></div></div>';
      if (!g.other && g.list.length > 1) {
        var mi = g.sel.length ? g.sel[0].i : 0;
        p += '<div class="vgcf-r"><label class="vgcf-r__l" for="vgcf-r-' + uid + '">' + esc(t.min) + ' <output class="vgcf-r__o"></output></label>' +
          '<input type="range" class="vgcf-r__i" id="vgcf-r-' + uid + '" min="0" max="' + (g.list.length - 1) + '" step="1" value="' + mi + '">' +
          '<div class="vgcf-r__e" aria-hidden="true"><span>' + esc(disp(g.list[0], loc)) + '</span><span>' + esc(disp(g.top, loc)) + '</span></div></div>';
      }
      p += '<div class="vgcf-s" role="group" aria-label="' + esc(g.n + ' · ' + t.scores) + '">';
      g.list.forEach(function (o) {
        p += '<button type="button" class="vgcf-o' + (o.on ? ' is-on' : '') + '" id="vgcf-o-' + uid + '-' + k + '-' + o.i + '" data-i="' + o.i + '" aria-pressed="' + o.on + '"' + (o.c === 0 && !o.on ? ' disabled' : '') + '>' +
          '<span class="vgcf-o__s">' + esc(g.other ? o.lab : disp(o, loc)) + '</span><span class="vgcf-o__c">' + o.c + '</span></button>';
      });
      p += '</div>';
      panel.innerHTML = p;
      var rng = panel.querySelector('.vgcf-r__i');
      if (rng) {
        var out = panel.querySelector('.vgcf-r__o');
        var upd = function () {
          var i = +rng.value, n = 0; g.list.forEach(function (o) { if (o.i >= i) n += o.c; });
          out.textContent = (i === 0 ? t.all : '≥ ' + disp(g.list[i], loc)) + ' · ' + n + ' ' + t.wines;
          rng.style.setProperty('--p', (g.list.length > 1 ? i / (g.list.length - 1) * 100 : 0) + '%');
          panel.querySelectorAll('.vgcf-o').forEach(function (b) { b.classList.toggle('is-pre', +b.dataset.i >= i); });
        };
        rng.addEventListener('input', upd);
        rng.addEventListener('change', function () {
          var i = +rng.value, ch = [];
          g.list.forEach(function (o) { ch = ch.concat(setOpt(o, o.i >= i)); });
          apply(ch);
        });
        upd();
        if (!g.sel.length) panel.querySelectorAll('.vgcf-o').forEach(function (b) { b.classList.remove('is-pre'); });
      }
      grid.hidden = true; panel.hidden = false;
      root.classList.toggle('vgcf--anim', !!anim);
      root.classList.add('is-open');
    }
    function closePanel(focusK) {
      OPEN.k = null;
      panel.hidden = true; grid.hidden = false; root.classList.remove('is-open');
      root.classList.add('vgcf--anim');
      if (focusK) { var b = grid.querySelector('[data-k="' + focusK + '"]'); if (b) b.focus(); }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
      e.preventDefault();
      if (b.classList.contains('vgcf-t')) { openPanel(b.dataset.k, true); var bk = panel.querySelector('.vgcf-back'); if (bk) bk.focus(); return; }
      if (b.classList.contains('vgcf-back')) { closePanel(OPEN.k); return; }
      var g = G[OPEN.k];
      if (b.classList.contains('vgcf-clr') && g) { var ch = []; g.list.forEach(function (o) { ch = ch.concat(setOpt(o, false)); }); apply(ch); return; }
      if (b.classList.contains('vgcf-o') && g) {
        var o = g.list[+b.dataset.i]; var on = !o.on; o.on = on;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
        apply(setOpt(o, on)); return;
      }
      if (b.dataset.x) { var gx = G[b.dataset.x]; var cx = []; gx.list.forEach(function (o) { cx = cx.concat(setOpt(o, false)); }); b.classList.add('is-gone'); apply(cx); }
    });
    var escK = false;
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && OPEN.k && !panel.hidden) { escK = true; e.preventDefault(); e.stopPropagation(); closePanel(OPEN.k); } }, true);
    root.addEventListener('keyup', function (e) { if (e.key === 'Escape' && escK) { escK = false; e.stopPropagation(); } }, true);
    if (OPEN.k && G[OPEN.k]) openPanel(OPEN.k, false);
    if (OPEN.f) { var fe = document.getElementById(OPEN.f); if (fe && root.contains(fe)) fe.focus({ preventScroll: true }); OPEN.f = null; }
  }

  function scan() { document.querySelectorAll('[data-vgcf]:not([data-vgcf-init])').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(scan, 30); }).observe(document.documentElement, { childList: true, subtree: true });
})();
